// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__KfclB","lineButtons":"vehicleItem_lineButtons__xARzy","twoInLine":"vehicleItem_twoInLine__LNcEs"};